import Button from "../Common/Button";
import { useTranslation } from "react-i18next";

const AccountHeader = ({ isEditing, onEdit, onSave, onCancel, isValid }) => {
    const { t } = useTranslation();

    return (
        <div className="border-b border-slate-200 pb-6">
            <div className="flex flex-col gap-4 md:flex-row md:items-start md:justify-between">
                <div>
                    <h1 className="text-lg font-semibold text-slate-900">{t("SIDEBAR_ACCOUNT")}</h1>
                    <p className="mt-1 text-sm text-slate-500">
                        {t("ACCOUNT_HEADER_SUBTITLE")}
                    </p>
                </div>
                <div className="flex flex-wrap items-center gap-3">
                    {isEditing ? (
                        <>
                            <Button
                                type="button"
                                onClick={onSave}
                                disabled={!isValid}
                                className="w-full md:w-[162px]"
                            >
                                {t("COMMON_SAVE")}
                            </Button>
                            <Button
                                type="button"
                                onClick={onCancel}
                                variant="secondary"
                                className="w-full md:w-[162px]"
                            >
                                {t("COMMON_CANCEL")}
                            </Button>
                        </>
                    ) : (
                        <Button
                            type="button"
                            onClick={onEdit}
                            variant="secondary"
                            className="w-full md:w-auto"
                        >
                            {t("COMMON_EDIT")}
                        </Button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default AccountHeader;
